import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-close",
  "use": "icon-close-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\" id=\"icon-close\">\n    <path fill-rule=\"nonzero\" d=\"M6.586 8L2.343 3.757a1 1 0 1 1 1.414-1.414L8 6.586l4.243-4.243a1 1 0 1 1 1.414 1.414L9.414 8l4.243 4.243a1 1 0 1 1-1.414 1.414L8 9.414l-4.243 4.243a1 1 0 0 1-1.414-1.414L6.586 8z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol